import { __t } from '../i18n/t'

const ROOT = 'root.serverError'

/**
 * O backend devolve no 400 de validação `body.errors = { "<campo>": "<frase pt-BR>" }`.
 * O react-admin já pinta cada campo quando o form recebe `errors`, mas o toast mostrava só
 * "Invalid request payload input", sem dizer qual campo. Aqui monta o texto do toast:
 * "Revise: campo: motivo; outro: motivo".
 */
export const composeServerErrorMessage = (errors: unknown): string | undefined => {
  if (!errors || typeof errors !== 'object') return undefined
  const parts = Object.entries(errors as Record<string, unknown>)
    .filter(([path, reason]) => path !== ROOT && typeof reason === 'string' && reason)
    // A frase vem em pt-BR do backend; é chave do catálogo, então traduz aqui (o toast é texto composto).
    .map(([path, reason]) => `${path}: ${__t(reason as string)}`)
  return parts.length ? __t('Revise: %{campos}', { campos: parts.join('; ') }) : undefined
}

/**
 * Põe o resumo em `errors['root.serverError']` e em `error.message`, preservando `error.body`
 * (é ele que o react-admin lê para marcar os campos). Devolve o próprio erro.
 */
export const withServerErrorMessage = <E>(error: E): E => {
  const body = (error as { body?: { errors?: Record<string, unknown> } } | undefined)?.body
  const message = composeServerErrorMessage(body?.errors)
  if (message && body?.errors) {
    body.errors[ROOT] = message
    ;(error as { message: string }).message = message
  }
  return error
}
